module.exports = __webpack_public_path__ + "img/the_international_logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/league/the_international_logo.png
// module id = RTF0
// module chunks = 1